import { postApiRequest } from 'api/index';
import { ICreateCalendarPlanParams, ICreateCalendarPlanResponse } from 'types/calendarPlan';

export const createCalendarPlan = (params: ICreateCalendarPlanParams): Promise<ICreateCalendarPlanResponse> => {
    return postApiRequest(`/calendar-plan/create/`, params);
};
